import React from 'react';

export interface SummaryListItemAction {
  href: string;
  text: string;
  visuallyHiddenText?: string;
}

export interface SummaryListItem {
  key: React.ReactNode;
  value: React.ReactNode;
  actions?: SummaryListItemAction[];
}

interface SummaryListProps {
  items: SummaryListItem[];
  heading?: string;
}

export const SummaryList: React.FC<SummaryListProps> = ({ items, heading }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className="summary-list-wrapper">
      {heading && <h2 className="summary-heading">{heading}</h2>}
      <ul className="summary-list" role="list">
        {items.map((item, index) => (
          <li key={index} className={item.actions && item.actions.length > 0 ? 'summary-list-item has-actions' : 'summary-list-item'}>
            <span className="label">{item.key}</span>
            <span className="value">{item.value}</span>
            {item.actions && item.actions.length > 0 && (
              <span className="actions">
                {item.actions.map((action, actionIndex) => (
                  <a key={actionIndex} href={action.href} className="summary-action-link">
                    {action.text}
                    {action.visuallyHiddenText && (
                      <span className="visually-hidden"> {action.visuallyHiddenText}</span>
                    )}
                  </a>
                ))}
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
